import React from 'react'
import { BusyButtonLink } from '@ztechapps/webui.button'
import { useContext } from './Context'

export const DeleteTaskButton = ({ index }) => {
  const { newTasks, setNewTasks } = useContext()
  return (
    <BusyButtonLink
      title="Delete this task"
      className="text-danger"
      bsSize="sm"
      icon={'trash'}
      onClick={() => {
        const tasks = [...newTasks]
        tasks.splice(index, 1)
        setNewTasks(tasks)
      }}
    />
  )
}
